import { TbSchool, TbBrandGithub } from "react-icons/tb";
import { HiCode, HiLocationMarker, HiOutlineMail } from "react-icons/hi";
import { BsInstagram } from "react-icons/bs";
import { RiLinkedinFill } from "react-icons/ri";
import { convertUriImg } from "../utils/GlobalFunc";

export const WORDS = {
  nama: "Dani Nur Ramadhan Prayogi",
  job: "Programmer",
  aboutTitle:
    "Hello, I am a software developer with 4 years of React and 2 years of Kotlin experience, passionate about creating scalable, user-friendly applications. I’ve delivered diverse projects, from web platforms to mobile apps, and thrive in collaborative, fast-paced environments.",
};

export const SECTION = [
  "About",
  "Resume",
  "Portfolio",
  //"Blog",
  //"Contact"
];

export const TITLE_PORTFOLIO = [
  "All",
  "Mobile Development",
  "Website Development",
  "IOT Development",
];

export const PORTFOLIO = [
  {
    title: "Tanyo Apps",
    desc: "Tanyo is a consulting platform that brings together experts with those who need fast, actual and reliable information.",
    idActive: 1,
    img: "tanyo.png",
    as: "Mobile Developer",
    links: [
      {
        label: "IOS",
        href: "https://apps.apple.com/id/app/tanyo/id1667436422",
      },
      {
        label: "Android",
        href: "https://play.google.com/store/apps/details?id=com.tanyo.app",
      },
    ],
  },
  {
    title: "Digital Smart Care Lite",
    desc: "Digital Smart Care (DSC) Consumer is an application that used in Grapari Telkomsel to service the consumer for register the SIM card, update profile account, and manage data Telkomsel consumer.",
    idActive: 1,
    // img: "usahaku.jpg",
    as: "Mobile Developer",
  },
  {
    title: "DigiPOS Aja!",
    desc: "Digipos or Digital Point of Sales is an application used by Authorize Dealer, Sales Force, Direct Sales Agent and Outlet to monitor, distribute and sell Telkomsel products.",
    idActive: 1,
    img: "digipos-aja.jpg",
    as: "Mobile Developer",
    links: [
      {
        label: "Android",
        href: "https://play.google.com/store/apps/details?id=com.telkomsel.digiposaja&hl=id&gl=US",
      },
    ],
  },
  {
    title: "99% Usahaku",
    desc: "99% Usahaku is a platform or application launched by Telkomsel to help Small and Medium Enterprises (SMEs) to be more efficient, advanced and developing through digital solutions offered by Telkomsel and Telkomsel's partners registered in the application.",
    idActive: 1,
    img: "usahaku.jpg",
    as: "Mobile Developer",
    links: [
      {
        label: "IOS",
        href: "https://apps.apple.com/id/app/99-usahaku/id1553008368",
      },
      {
        label: "Android",
        href: "https://play.google.com/store/search?q=99+usahaku&c=apps",
      },
    ],
  },
  {
    title: "Permata Mobile X",
    desc: "Permata Mobile X is mobile banking by PT. Bank Permata Tbk",
    idActive: 1,
    img: "permata.jpg",
    as: "Mobile Developer | Lead Squad",
    links: [
      {
        label: "IOS",
        href: "https://apps.apple.com/id/app/permatamobile-x/id1323973644",
      },
      {
        label: "Android",
        href: "https://play.google.com/store/apps/details?id=net.myinfosys.PermataMobileX",
      },
    ],
  },
  {
    title: "ATM Bussiness",
    desc: "ATM Bussiness is website internal monitoring ATM by PT. Bank CIMB Niaga, Tbk",
    idActive: 2,
    img: "atm-cimb.png",
    as: "Website Developer",
  },
  {
    title: "BTN Properti Mobile",
    desc: "BTN Properti Mobile is 1st integrated property platform in Indonesia by PT. Bank Tabungan Negara(Persero), Tbk",
    idActive: 1,
    idActive2: 2,
    img: "btn-properti.jpg",
    as: "Mobile Developer",
    links: [
      {
        label: "IOS",
        href: "https://apps.apple.com/id/app/btn-properti/id1641042026",
      },
      {
        label: "Android",
        href: "https://play.google.com/store/apps/details?id=btn.properti.android&hl=in",
      },
      {
        label: "Website",
        href: "https://www.btnproperti.co.id/",
      },
    ],
  },
  {
    title: "System Parking Guide",
    desc: "I built an IoT ecosystem for system parking guidance, at IPC Tanjung Priok",
    idActive: 3,
    img: "parking-guide.png",
    as: "Electrical Engineering",
  },
  {
    title: "Timer AirSoftgun",
    desc: "I made two tools for Timer Softgun, first to stop the timer I made a vibration detector on the target shooting, second I made a timer to start the time and see the duration it takes the user to shoot at the target",
    idActive: 3,
    img: "timer-softgun.png",
    as: "Electrical Engineering",
  },
  {
    title: "Learning module to make smart home",
    desc: "I created a smart home learning module to provide guidance on making a smart home, through a replica.",
    idActive: 3,
    img: "module-smarthome.png",
    as: "Electrical Engineering",
  },
];

export const EXPERIENCE = [
  {
    title: "Experience",
    icon: <HiCode />,
    data: [
      {
        title: "PT. DAnS Multi Pro",
        subTitle: "March 2023 - Now | Contract",
        desc: "Mobile Developer",
      },
      {
        title: "Tanyo",
        subTitle: "December 2022 - March 2023 | Freelance",
        desc: "Mobile Developer",
      },
      {
        title: "PT. Infosys Solusi Terpadu",
        subTitle: "July 2021 - March 2023 | Permanent",
        desc: "Front End Developer",
      },

      {
        title: "Without Company",
        subTitle: "Agustus 2021 - November 2021 | Freelance",
        desc: "IOT Engineer ",
      },
      {
        title: "PT. Nocola IOT Solution",
        subTitle: "November 2019 - April 2020 | Internship",
        desc: "IOT Engineer & Production Support",
      },
    ],
  },
  {
    title: "Education",
    icon: <TbSchool />,
    data: [
      {
        title: "Binus University",
        subTitle: "2022 - 2025 | Online Learning",
        desc: "Information Systems",
      },
      {
        title: "State Vocational High School 1 Purbalingga",
        subTitle: "2018 - 2021",
        desc: "Software Engineering",
      },
    ],
  },
];

export const SKILLS = [
  {
    title: "JavaScript",
    desc: "Proficient Level",
    progress: "90%",
  },
  {
    title: "TypesScript",
    desc: "Proficient Level",
    progress: "85%",
  },
  {
    title: "React Native",
    desc: "Proficient Level",
    progress: "90%",
  },
  {
    title: "ReactJS",
    desc: "Competent Level",
    progress: "75%",
  },
  {
    title: "NextJS",
    desc: "Competent Level",
    progress: "75%",
  },
  {
    title: "Kotlin",
    desc: "Competent Level",
    progress: "70%",
  },
  {
    title: "IOT Engineer",
    desc: "Competent Level",
    progress: "75%",
  },
  {
    title: "Java",
    desc: "Beginner Level",
    progress: "50%",
  },
  {
    title: "Flutter",
    desc: "Beginner Level",
    progress: "50%",
  },
  {
    title: "Swift",
    desc: "Beginner Level",
    progress: "40%",
  },
];

export const CONTACT = [
  {
    title: "Mail",
    label: "daninurrp@gmail.com",
    icon: <HiOutlineMail />,
    href: "mailto:daninurrp@gmail.com",
  },
  {
    title: "Linkedin",
    label: "Dani Nur Ramadhan Prayogi",
    icon: <RiLinkedinFill />,
    href: "https://www.linkedin.com/in/dani-nur-ramadhan-prayogi-1416aa203/",
  },
  {
    title: "Github",
    label: "dnrpcode",
    icon: <TbBrandGithub />,
    href: "https://github.com/dnrpcode",
  },
  {
    title: "Instagram",
    label: "dnrp_17",
    icon: <BsInstagram />,
    href: "https://www.instagram.com/dnrp_17/",
  },
  {
    title: "Location",
    label: "Banjarnegara, Indonesia",
    icon: <HiLocationMarker />,
    href: "https://www.google.com/maps/place/Banjarnegara,+Central+Java/@-7.4465603,109.399416,11z/data=!3m1!4b1!4m6!3m5!1s0x2e7aa8dfd3f7967d:0x582948b304c4754b!8m2!3d-7.4419381!4d109.5467738!16s%2Fm%2F02qrw8w?entry=tts&shorturl=1",
  },
];

export const QUOTES = [
  {
    name: "Me",
    img: convertUriImg("avatar/me.png"),
    desc: "Value > Effort.",
    date: "2022",
  },
  {
    name: "Oscar Wilde",
    img: convertUriImg("avatar/avatar-1.png"),
    desc: "Experience is the name everyone gives to their mistakes.",
    date: "-",
  },
  {
    name: "Austin Freeman",
    img: convertUriImg("avatar/avatar-4.png"),
    desc: "Simplicity is the soul of efficiency.",
    date: "-",
  },
  {
    name: "Martin Fowler",
    img: convertUriImg("avatar/my-avatar.png"),
    desc: "When to use iterative development? You should use iterative development only on projects that you want to succeed.",
    date: "-",
  },
];

export const IM_DOING = [
  {
    title: "Mobile Development",
    img: "mob-dev.png",
    desc: "I build mobile apps with clean and efficient code use React Native.",
  },
  {
    title: "Web Development",
    img: "web-dev.png",
    desc: "I build website with clean, efficient code and responsive on various platforms use React JS.",
  },
  {
    title: "Web Design",
    img: "web-design.png",
    desc: "I designed an application with a modern design, simple design and user friendly.",
  },
  {
    title: "Internet Of Thinks",
    img: "iot-dev.png",
    desc: "I'm building a smart device that can execute a command and program it to connect to each other.",
  },
];

export const CLIENTS = [
  {
    name: "PT. Nocola IOT Solution",
    href: "",
    img: "nocola.png",
  },
  {
    name: "PT. Infosys Solusi Terpadu",
    href: "",
    img: "ist.png",
  },
  {
    name: "Permata",
    href: "",
    img: "permata.png",
  },
  {
    name: "BTN Properti",
    href: "",
    img: "btn-properti.png",
  },
  {
    name: "CIMB Niaga",
    href: "",
    img: "cimb.png",
  },
];
